// sendHapticFeedback.ts

import { MiniKit } from "@worldcoin/minikit-js";

export interface SendHapticFeedbackProps {
    type:
        | "onboarding-change-index"
        | "onboarding-typing-animation"
        | "payment"
        | "testing"
        | "button-click"
        | "heavy"
        | "light"
        | "medium";
    async?: boolean;

    // FOR "onboarding-typing-animation":
    typingChars?: number;
    typingCharDelay?: number;
}

export const sendHapticFeedback = async (props: SendHapticFeedbackProps) => {
    if (
        MiniKit &&
        MiniKit.isInstalled?.() &&
        typeof MiniKit.sendHapticFeedback === "function"
    ) {
        switch (props.type) {
            case "onboarding-change-index":
                await MiniKit.sendHapticFeedback({
                    hapticsType: "impact",
                    style: "heavy",
                });
                break;

            case "onboarding-typing-animation":
                // If typingChars and typingCharDelay are provided, we'll trigger multiple haptic feedbacks
                if (
                    props.typingChars &&
                    props.typingChars > 0 &&
                    props.typingCharDelay
                ) {
                    // Calculate the adjusted interval between haptic feedback commands
                    // This accounts for the execution time of each haptic command
                    // const adjustedInterval = Math.max(
                    //     props.typingCharDelay - HAPTIC_EXECUTION_TIME,
                    //     10
                    // );

                    // First immediate feedback
                    const startTime = performance.now();
                    await MiniKit.sendHapticFeedback({
                        hapticsType: "impact",
                        style: "medium",
                    });

                    // Measure actual execution time of the first haptic feedback
                    const actualExecutionTime = performance.now() - startTime;

                    // Refine our adjusted interval based on the actual execution time
                    const refinedInterval = Math.max(
                        props.typingCharDelay - actualExecutionTime,
                        10,
                    );

                    // Schedule the rest of the haptic feedback events
                    const remainingChars = props.typingChars - 1;
                    if (remainingChars > 0) {
                        let currentChar = 1;
                        let lastExecutionTime = 0;
                        console.log("lastExecutionTime:", lastExecutionTime);

                        // Create a promise that resolves when all haptic feedbacks are done
                        const hapticPromise = new Promise<void>((resolve) => {
                            const interval = setInterval(async () => {
                                const execStart = performance.now();

                                await MiniKit.sendHapticFeedback({
                                    hapticsType: "impact",
                                    style: "medium",
                                });

                                // Measure actual execution time for this haptic feedback
                                lastExecutionTime =
                                    performance.now() - execStart;

                                currentChar++;
                                if (currentChar >= props.typingChars!) {
                                    clearInterval(interval);
                                    resolve();
                                }
                            }, refinedInterval);
                        });

                        // Wait for all haptic feedbacks to complete if async mode is used
                        if (props.async) {
                            await hapticPromise;
                        }
                    }
                } else {
                    // Default single haptic feedback
                    await MiniKit.sendHapticFeedback({
                        hapticsType: "impact",
                        style: "medium",
                    });
                }
                break;

            case "heavy":
                await MiniKit.sendHapticFeedback({
                    hapticsType: "impact",
                    style: "heavy",
                });
                break;

            case "payment":
                await MiniKit.sendHapticFeedback({
                    hapticsType: "impact",
                    style: "heavy",
                });
                break;
            case "button-click":
                await MiniKit.sendHapticFeedback({
                    hapticsType: "impact",
                    style: "medium",
                });
                break;

            case "testing":
                await MiniKit.sendHapticFeedback({
                    hapticsType: "impact",
                    style: "medium",
                });
                break;

            case "light":
                await MiniKit.sendHapticFeedback({
                    hapticsType: "impact",
                    style: "light",
                });
                break;

            case "medium":
                await MiniKit.sendHapticFeedback({
                    hapticsType: "impact",
                    style: "medium",
                });
                break;
        }
    }
};
